import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import List from '../InstaOrders/List'
import TransactionsList from '../InstaTransaction/List'

import ReactExport from 'react-export-excel';


import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'Approved', value: 'Approved' },
    { key: 'Pending', value: 'Pending' },
    { key: 'Rejected', value: 'Rejected' },
]
const searchBy = [
    { key: 'Title', value: 'title' },
];


export function MaterialUIPickers(props) {
    
    var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();
    var firstDay = new Date(),
        y = date.getFullYear(),
        m = date.getMonth();

const [selectedDate, setSelectedDate] = React.useState(firstDay);

const handleDateChange = (date) => {
    setSelectedDate(date);
    props.setDate(date);
};

return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container justifyContent="space-around">
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="none"
                id={props.id}
                label={props.label}
                value={selectedDate}
                onChange={handleDateChange}
                maxDate={new Date()}
                autoOk={true}
                KeyboardButtonProps={{
                    'aria-label': 'change date'
                }}
            />
        </Grid>
    </MuiPickersUtilsProvider>
);
}


class Users extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'name',
        alert: 0,
        alertMessage: '',
        data: [],
        selectedRow: [],
        flag: true,
        name:'',
        showList: false,
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'insta/insta-users'
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            flag: false,
                            alert: 0
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    
    listOrder = (rowData) => {
        if (this._isMounted) {
            this.setState({ showList: true,selectedRow: rowData });
        }
    };
    
    hideOrder  = () => {
        if (this._isMounted) {
            this.setState({ showList: false, selectedRow: [] });
        }
    };
    listTransactions = (rowData) => {
        if (this._isMounted) {
            this.setState({ showTransactions: true,selectedRow: rowData });
        }
    };
    
    hideTransactions  = () => {
        if (this._isMounted) {
            this.setState({ showTransactions: false, selectedRow: [] });
        }
    };

    
    
    
    
    
    render() {
        
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                {!this.state.showList && !this.state.showTransactions &&<div>
                        <Row>
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                Insta Users
                            </h4>
                        </Row>
                        <div>
                            <hr />
                        </div>
                        <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='Status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !=='Status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                </Form.Group>
                            </Col>
                        </Row>

                        <MaterialTable
                            components={{
                                Pagination: PatchedPagination
                            }}
                            title="Users"
                            columns={[
                                {
                                    title: 'Name',
                                    field: 'name'
                                },
                                {
                                    title: 'Phone',
                                    field: 'phone'
                                },
                                {
                                    title: 'Orders',
                                    field: '',
                                    render: (row) => (<Button
                                        variant="primary"
                                        onClick={(e) =>
                                            this.listOrder(row)
                                        }
                                    >
                                        List
                                    </Button>)
                                },
                                {
                                    title: 'Transactions',
                                    field: '',
                                    render: (row) => (<Button
                                        variant="primary"
                                        onClick={(e) =>
                                            this.listTransactions(row)
                                        }
                                    >
                                        List
                                    </Button>)
                                },
                               
                                
                                
                            ]}
                            data={this.state.data}
                            options={{
                                filtering: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                actionsColumnIndex: -1
                            }}
                        />

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.data.length <
                                    this.state.perPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {this.state.data.length >=
                                    this.state.perPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                </div>}
               

                {this.state.showList && <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideOrder}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                 {this.state.selectedRow.name} Orders
                            </h4>
                        </Row>

                        <List customer={this.state.selectedRow} {...this.props} />
                </div>}

                {this.state.showTransactions && <div>
                        <Row>
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={this.hideTransactions}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                            >
                                 {this.state.selectedRow.name} Transactions
                            </h4>
                        </Row>

                        <TransactionsList customer={this.state.selectedRow} {...this.props} />
                </div>}

                
            </Container>
        );
    }
}

export default Users;
